import type { EvaluationContext, EvaluationContextValue } from '@openfeature/web-sdk';
import { OpenFeature } from '@openfeature/web-sdk';
import { useEffect } from 'react';

type FeatureFlagContext = { targetingKey?: string } & Record<
  string,
  EvaluationContextValue | undefined
>;

export const applyFeatureFlagContext = (serialized: string | null): Promise<void> => {
  if (serialized === null) return Promise.resolve();

  return OpenFeature.setContext(JSON.parse(serialized) as EvaluationContext).catch(
    (err: unknown) => {
      console.error('[applyFeatureFlagContext] OpenFeature.setContext failed:', err);
    },
  );
};

export const useFeatureFlagContextSync = (context: FeatureFlagContext | null): void => {
  const serialized = context ? JSON.stringify(context) : null;

  useEffect(() => {
    applyFeatureFlagContext(serialized);
  }, [serialized]);
};
